<template>
	<v-img
		:src="currentSrc"
		@error="handleError"
		v-on="cleanListeners"
	>
		<slot />
		<template v-slot:placeholder>
			<slot name="placeholder">
				<div style="width:100%;height:100%"></div>
			</slot>
		</template>
	</v-img>
</template>

<script>
export default {
	name: "SmartImg",
	props: {
		product: { type: Object, default: null },
		backImg: {
			type: Function,
			default: (p) => (p && p.imageLinks) ? p.imageLinks : []
		}
	},
	data() {
		return {
			idx: 0
		};
	},
	computed: {
		candidates() {
			const list = Array.isArray(this.urls) && this.urls.length
				? this.urls.slice()
				: (this.backImg(this.product) || []);

			return Array.from(new Set(list));
		},
		currentSrc() {
			return this.candidates[this.idx];
		},
		cleanListeners() {
			// eslint-disable-next-line no-unused-vars
			const { error, ...rest } = this.$listeners;
			return rest;
		}
	},
	methods: {
		handleError() {
			if (this.idx < this.candidates.length - 1) {
				this.idx += 1;
			}
		}
	}
};
</script>
